import React from "react";
import { Box, Paper, Typography, IconButton } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";

export default function StatTile({
  title,
  value,
  icon,
  tint = "#F8F8F8",        // card bg
  iconBg = "#FFF3CD",      // icon box bg
  onClick,                 // optional
}) {
  return (
    <Paper
      onClick={onClick}
      elevation={1}
      sx={{
        p: 2,
        borderRadius: 3,
        cursor: onClick ? "pointer" : "default",
        bgcolor: tint,
        display: "flex",
        alignItems: "center",
        gap: 2,
        transition: "transform .15s ease, box-shadow .15s ease",
        "&:hover": { transform: onClick ? "translateY(-2px)" : "none", boxShadow: 3 },
      }}
    >
      {/* Icon pill */}
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: iconBg,
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>

      {/* Texts */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="subtitle1" sx={{ color: "text.secondary", mb: 0.5 }}>
          {title}
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 600, color: "primary.main", lineHeight: 1 }}>
          {value}
        </Typography>
      </Box>

      {/* Chevron */}
      <IconButton size="small" edge="end" sx={{ ml: 1 }}>
        <ChevronRight />
      </IconButton>
    </Paper>
  );
}
